import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import router from '@/router/index.js'
import App from './App.vue'
import i18n from './language/index.js'
import 'swiper/dist/css/swiper.min.css';
import 'swiper/dist/js/swiper.min';
import jquery from "jquery"


import VueLuckyCanvas from '@lucky-canvas/vue'
Vue.use(VueLuckyCanvas)
Vue.use(ElementUI);
Vue.prototype.$bus = new Vue()
Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});

new Vue({
	render: h => h(App),
	router,
	jquery,
	i18n
	
}).$mount('#app')